////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const recapStock = {
	// region POST REQUESTS ...
	/**
	 *
	 * @return {{payload: { Array }, type: string}}
	 * @param {object} filters
	 * @param {object} queryParams
	 * @example
	 * filters: {
	 * 		"withFilters" : false,
	 *  	"userKioskScope" :
	 * 		{
	 *     		"kiosksInLocalScope" : []
	 * 		},
	 * 		"selectedKioskIds" : [],
	 * 		"selectedKioskBrandLabels" : [],
	 * 		"selectedItemLabels" : [],
	 * 		"selectedItemTypes" : [],
	 * 		"selectedBrandIds" : [],
	 * 		"selectedFamilyIds" : []
	 * }
	 * queryParams: {
	 *     page: "5",
	 *     size: '50'
	 * }
	 */
	postRecapStockRequest: (filters = {}, queryParams = { page: '0', size: '250', sort: 'kiosk.store.company.labelToDisplay', nameDir: 'asc' }) => ({
		type: ActionsTypes.POST_RECAP_STOCK_REQUEST,
		payload: {
			filters,
			queryParams,
		},
	}),
	postRecapStockSuccess: (data) => ({
		type: ActionsTypes.POST_RECAP_STOCK_SUCCESS,
		payload: { data },
	}),
	postRecapStockFailure: () => ({
		type: ActionsTypes.POST_RECAP_STOCK_FAILURE,
		payload: {},
	}),
	// endregion

	// region PUT REQUESTS ...
	putRecapStockRequest: (data) => ({
		type: ActionsTypes.PUT_RECAP_STOCK_REQUEST,
		payload: { data },
	}),
	putRecapStockSuccess: (data) => ({
		type: ActionsTypes.PUT_RECAP_STOCK_SUCCESS,
		payload: { data },
	}),
	putRecapStockFailure: (error) => ({
		type: ActionsTypes.PUT_RECAP_STOCK_FAILURE,
		payload: { error },
	}),
	// endregion ...

	postRecapStockFromRedirect: (filters = {}, queryParams = { page: '0', size: '50' }) => ({
		type: ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT,
		payload: {
			filters,
			queryParams,
		},
	}),
	postRecapStockFromRedirectSuccess: (data) => ({
		type: ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT_SUCCESS,
		payload: { data },
	}),
	postRecapStockFromRedirectFailure: () => ({
		type: ActionsTypes.POST_RECAP_STOCK_FROM_REDIRECT_FAILURE,
		payload: {},
	}),
	resetFiltersInfos: () => ({
		type: ActionsTypes.RESET_RECAP_STOCK_FILTERS_INFOS,
	}),
	resetRecapStock: () => ({
		type: ActionsTypes.RESET_RECAP_STOCK,
	}),
}

export default recapStock
